module.exports = __webpack_public_path__ + "static/img/hospital.f7bfd579.png";